export default __webpack_public_path__ + "static/media/Logo.7aac87e3.png";